<template>
    <div class="loanform_wizrd_bg" :class="{ thankyou_form: submited }">
        <div class="loader_wrapper" v-if="loading" style="position: fixed">
            <div class="triple-spinner"></div>
        </div>
        <!-- <span v-text="loading"></span> -->
        <div class="card">
            <div class="card-body p-0">
                <div class="loanform_wizard_title">
                    <h2>{{ title }}</h2>
                </div>

                <div class="loanform_wizard_col_box loan_against_share_form">
                    <div v-if="submited" class="successful_icon">
                        <img :src="icon" alt="check" class="img-fluid" />
                    </div>

                    <div v-if="!submited" class="register_wizard_form_bg">
                        <form-wizard
                            shape="circle"
                            color="#429abd"
                            error-color="red"
                            :needVerification="needVerification"
                            @on-saved-successfully="updateStatus"
                            @on-complete="onComplete"
                        >
                            <tab-content
                                v-for="(form, index) in forms"
                                :key="index"
                                title="form.form_title"
                                icon="ti-user"
                                :before-change="() => validate(`form${index}`)"
                            >
                                <firststep
                                    :ref="`form${index}`"
                                    :fields="form.fields"
                                    :title="form.form_title"
                                    :className="form.class"
                                    :options="form.options"
                                    :model="form.model"
                                    :final-model="finalModel"
                                    @on-validate="onStepValidate"
                                ></firststep>
                            </tab-content>
                            <button
                                slot="next"
                                type="submit"
                                class="btn btn-primary"
                            >
                                Next
                            </button>
                            <button
                                slot="prev"
                                type="button"
                                class="btn btn-outline-primary"
                            >
                                Previous
                            </button>
                            <button
                                slot="finish"
                                type="button"
                                class="btn btn-primary"
                            >
                                Submit
                            </button>
                        </form-wizard>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import formData from "../../form-json/loan-against-share.json";

export default {
    name: "WizardLoanAgainstShare",
    props: {
        isloggedin: {
            type: String,
        },
    },
    data() {
        return {
            copyaddress: false,
            loading: false,
            user: [],
            needVerification: false,
            isEmploymentSelected: false,
            forms: formData[0],
            finalModel: {},
            title: "Find the best Loan for you",
            submited: false,
            verifyScreen: {
                form_title: "Verify your mobile number!",
                class: "col-sm-6",
                fields: {
                    0: {
                        inputType: "abhiloans_verify",
                        inputTypeName: "verificationotp",
                        label: "OTP",
                        inputPlaceholder: "OTP",
                        validation: { required: true },
                        tooltip: "OTP",
                        mobileNumberField: "verificationMobile",
                    },
                },
                model: {
                    verificationotp: null,
                    verified: null,
                },
                options: {},
            },
        };
    },
    mounted() {
        this.autofillReferralData();
    },
    components: {
        FormWizard: () => import("../wizard/FormWizard.vue"),
        TabContent: () => import("../wizard/TabContent.vue"),
        firststep: () => import("../wizard/firststep.vue"),
    },
    created() {
        if (this.isloggedin) {
            this.user = JSON.parse(this.isloggedin);
            console.log(this.user);
            this.forms[1].model.first_name = this.user.first_name;
            this.forms[1].model.dob = this.user.dob;
            this.forms[1].model.pan_number = this.user.pan_number;
            this.forms[1].model.email = this.user.email;
            this.forms[1].model.mobile = this.user.mobile;
            this.forms[1].model.verified = true;
            this.finalModel["user_id"] = this.isloggedin.id;

            if (this.user.mobile == null || this.user.mobile == "") {
                this.forms[1].fields[7] = {
                    inputType: "abhiloans_verify",
                    inputTypeName: "verificationotp",
                    label: "OTP",
                    inputPlaceholder: "OTP",
                    validation: { required: true },
                    tooltip: "OTP",
                    mobileNumberField: "mobile",
                };
                this.needVerification = true;
            }
        }
    },
    methods: {
        autofillReferralData() {
            const queryString = window.location.search;
            const urlParams = new URLSearchParams(queryString);
            const dataParamtwo = urlParams.get("referral");
            if (dataParamtwo) {
                try {
                    sessionStorage.setItem("referral_code", dataParamtwo);
                    this.forms[1].model.referral_code = dataParamtwo;
                } catch (error) {
                    console.error("Error parsing combined data:", error);
                }
            }
        },
        updateStatus() {
            this.submited = true;
        },
        onPaste(evt) {
            console.log("on paste", evt);
            return true;
        },
        onComplete() {
            this.loading = true;

            if (this.loading) {
                const loaderWrapperDiv = document.createElement("div");
                loaderWrapperDiv.classList.add("loader_wrapper");

                const tripleSpinnerDiv = document.createElement("div");
                tripleSpinnerDiv.classList.add("triple-spinner");

                loaderWrapperDiv.appendChild(tripleSpinnerDiv);
                document.body.appendChild(loaderWrapperDiv);
            }

            this.finalModel["referral_code"] =
                sessionStorage.getItem("referral_code");
            this.finalModel["verify_response"] =
                sessionStorage.getItem("verify_response");
            this.finalModel["selected_bank_id"] = $(
                "input[name='selected_bank_id']"
            ).val();
            console.log(this.finalModel["referral_code"]);
            axios
                .post("loan-against-securities", this.finalModel)
                .then((response) => {
                    if (response.data.status) {
                        window.location.href = response.data.redirect_url;
                        Swal.fire({
                            icon: "success",
                            title: "Success",
                            text: response.data.message,
                        });
                    } else {
                        Swal.fire({
                            icon: "error",
                            title: "Something went wrong",
                            text: response.data.message,
                        });
                        console.log(response.data);
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        validate(ref) {
            window.scrollTo({ top: 0, behavior: "smooth" });
            return this.$refs[ref][0].validate();
        },
        onStepValidate(validated, model) {
            if (validated) {
                this.finalModel = { ...this.finalModel, ...model };
            }
        },
        logStore() {
            axios
                .post("log-store", {
                    loan_type: "15",
                    log_data: this.finalModel,
                })
                .then((response) => {})
                .catch((error) => {
                    console.log("error2");
                });
        }
    },
    watch: {
        finalModel: {
            deep: true,
            handler(val) {
                this.logStore();
            },
        },
    },
};
</script>
